(function () {
  function initCalculator(root) {
    if (root.dataset.fcInit) return;
    root.dataset.fcInit = '1';

    var tabsTrack = root.querySelector('[data-fc-tabs]');
    if (!tabsTrack) return;

    var tabs = Array.prototype.slice.call(tabsTrack.querySelectorAll('[data-fc-tab]'));
    var headings = Array.prototype.slice.call(root.querySelectorAll('[data-fc-heading]'));
    var badges = Array.prototype.slice.call(root.querySelectorAll('[data-fc-badge]'));
    var products = Array.prototype.slice.call(root.querySelectorAll('[data-fc-product]'));

    function selectTier(index) {
      tabs.forEach(function (tab) {
        var on = Number(tab.dataset.fcTab) === index;
        tab.classList.toggle('is-current', on);
        tab.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      headings.forEach(function (heading) {
        var on = Number(heading.dataset.fcHeading) === index;
        heading.classList.toggle('is-active', on);
        heading.hidden = !on;
      });

      badges.forEach(function (badge) {
        var on = Number(badge.dataset.fcBadge) === index;
        badge.classList.toggle('is-active', on);
        badge.hidden = !on;
      });

      products.forEach(function (product) {
        var unlocked = Number(product.dataset.fcTierIndex) <= index;
        product.classList.toggle('is-unlocked', unlocked);
      });

      scrollTabIntoView(index);
    }

    function scrollTabIntoView(index) {
      var tab = tabs[index];
      if (!tab) return;

      var trackRect = tabsTrack.getBoundingClientRect();
      var tabRect = tab.getBoundingClientRect();
      var isFullyVisible = tabRect.left >= trackRect.left && tabRect.right <= trackRect.right;
      if (isFullyVisible) return;

      var targetScrollLeft =
        tabsTrack.scrollLeft + (tabRect.left - trackRect.left) - (trackRect.width - tabRect.width) / 2;
      tabsTrack.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
    }

    tabsTrack.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-fc-tab]');
      if (!tab || !tabsTrack.contains(tab)) return;
      selectTier(Number(tab.dataset.fcTab));
    });

    // Theme editor: jump to the tab whose block was just selected.
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      var tab = e.target.querySelector ? e.target.querySelector('[data-fc-tab]') : null;
      if (tab) selectTier(Number(tab.dataset.fcTab));
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-fc-root]')).forEach(initCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: a newly added section instance isn't in the DOM at
  // DOMContentLoaded time -- pick it up when Shopify injects it.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-fc-root]') : null;
    if (root) initCalculator(root);
  });
})();
